/* @flow */
import { reducer, initialState } from 'payments/reducers/PaymentSources';
import { ReduceStore } from 'flux/utils';
import { dispatcher } from 'lib/Dispatcher';

class PaymentSourceStore extends ReduceStore {
  getInitialState() {
    return initialState;
  }

  getPaymentSources() {
    return this.getState().paymentSources;
  }

  reduce(state, action) {
    return reducer(state, action);
  }
}

export default new PaymentSourceStore(dispatcher);



// WEBPACK FOOTER //
// ./src/payments/stores/PaymentSourceStore.js